module.exports = __webpack_public_path__ + "static/cel-logo-1ab3591b2a06b870d3e0fe428530b08b.jpg";